import React from "react";
import { Form, Input } from "antd";
import { DealManagerComponentModalProps } from "..";
import { getDigitsOnly } from "../../../utils";

const ChannelModal: React.FC<DealManagerComponentModalProps> = ({ form }) => {
	return (
		<>
			{/* <Form.Item
				name="id"
				label="ID"
				rules={[
					{ required: true, message: "Please input the ID!" },
				]}
			>
				<Input disabled onChange={e => form.setFieldValue("id", getDigitsOnly(e.target.value))} />
			</Form.Item> */}
			<Form.Item
				label="Channel Name"
				name="name"
				rules={[{ required: true, message: "Please enter the channel name" }]}
			>
				<Input placeholder="Enter channel name" />
			</Form.Item>
		</>
	);
};

export default ChannelModal;
